module.exports = __webpack_public_path__ + "static/bg6-9792ae12adfd3f3825a47f61c5237160.png";